import React, { useState, useEffect } from 'react'
import user from '../../store/user';
import InputBox from '../../components/InputBox'
import Button from '../../components/Button'
import { toast, ToastContainer } from 'react-toastify'
import './JobHistory.scss'
import fetchJobHistory from '../../services/fetchJobHistory';
import Loader from '../../components/Loader';
import moment from 'moment';
import { Table } from 'semantic-ui-react';
// import fetchRefreshJobHistory from '../../services/fetchRefreshJobHistory';
import { getQueryParams } from '../../utils/utilFunctions';

const unpublishMsgMap = {
    5:  "This position has been closed via "+ process.env.DOMAIN+".",
    6:  "This position has been closed via other channel.",
    1:  "This position has been closed.",
    2:  "This position has gone on hold.",
    3:  "The Recruiter has received enough applications.",
    4:  "Not disclosed by the Recruiter.",
    10: "Not disclosed by the Recruiter.",
    7: "Not received enough applicants.",
	  8: "Not received enough quality applicants",
}

const JobHistory = (props) => {

  const params = getQueryParams(props.location.search);
  const propMetaId = params.metaId;
  const propPublishId = params.publishId;

  const [metaId, setMetaId] = useState(propMetaId);
  const [publishId, setPublishId] = useState(propPublishId);
  const [isLoading, setIsLoading] = useState(false);
  const [jobData, setJobData] = useState([]);
  const [jobRefreshData, setJobRefreshData] = useState([]);
  const [hidingJD, setHidingJD] = useState(true);

  useEffect(() => {
    if (propMetaId) {
      searchByMetaId();
    } else if (propPublishId) {
      searchByPublishId();
    }
  }, []);

  const searchByMetaId = async () => {
    if (!metaId) return;
    props.history.push({ search: `?metaId=${metaId}` });
    const params = { metaId, }
    await searchHistory(params);
  };

  const searchByPublishId = async () => {
    if (!publishId) return;
    props.history.push({ search: `?publishId=${publishId}` });
    const params = { publishId, };
    await searchHistory(params)
  };

  const searchHistory = async (params) => {
    try {
      const profile = await user.getProfile();
      setIsLoading(true);

      const { data: jobHistoryData } = await fetchJobHistory(profile.id, params);
      setJobData(jobHistoryData.map(i => { return { ...i, hideJd: true } }));

      // const { data: jobRefreshData } = await fetchRefreshJobHistory(profile.id, params);
      // setJobRefreshData(jobRefreshData);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message || 'Something Went Wrong');
    }

  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (metaId) {
        searchByMetaId();
      } else if (publishId) {
        searchByPublishId();
      }
    }
  };

  const toggleCollapse = (d) => {
    const newData = [...jobData];
    const idx = jobData.findIndex((i) => i.id == d.id);
    newData[idx] = {
      ...newData[idx],
      hideJd: !newData[idx].hideJd
    };
    setJobData(newData);
  }

  const hideJD = (d) => {
    const newData = jobData.map(i => {
      return {
        ...i,
        hideJd: true
      }
    });
    setJobData(newData);
    setHidingJD(true);
  }

  const showJD = (d) => {
    const newData = jobData.map(i => {
      return {
        ...i,
        hideJd: false
      }
    });
    setJobData(newData);
    setHidingJD(false);

  }

  const statusMap = {
    rejected: { text: "Rejected", color: "red" },
    published: { text: "Published", color: "red" },
    unpublished: { text: "Unpublished", color: "red" },
    pending: { text: "Pending", color: "red" },
    refreshed: { text: "Refreshed" }
  }

  const getStatus = (d) => {
    if (d.rejected) {
      return statusMap.rejected;
    } else if (d.unpublish_msg) {
      return statusMap.unpublished;
    } else if (d.publish == 1) {
      return statusMap.published;
    } else if (d.publish == 3) {
      return statusMap.refreshed;
    } else {
      return statusMap.pending;
    }
  }

  return (
    <>
      <div className='job-history-page-container'>
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable={false}
          pauseOnHover
        />

        <div style={{ float: "right" }}>
          {
            hidingJD ?
              <Button skin={"dark"} clickButton={showJD} text="Show JD"></Button> :
              <Button skin={"dark"} clickButton={hideJD} text="Hide JD"></Button>
          }

        </div>
        <h2 className='job-history-page-heading'>Job History</h2>

        {/* <div className='search-container'>
            <div className='search-field-container'>
              <InputBox
                placeholder="Enter Job Id"
                type="number"
                name="metaId"
                value={metaId}
                onChange={(e) => setMetaId(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <Button skin="dark" text="Search" clickButton={searchByMetaId} />
            </div>
            <div className='search-field-container'>
              <InputBox
                placeholder="Enter Publish Id"
                type="number"
                name="publishId"
                value={publishId}
                onChange={(e) => setPublishId(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <Button
                skin="dark"
                text="Search"
                clickButton={searchByPublishId}
              />
            </div>
          </div> */}
        {isLoading ? (
          <Loader />
        ) : jobData.length ? (
          <div className='job-detail-history-list'>
            {jobData.map((data) => {
              return (
                // <Table.Row key={data.meta_id}>
                //   <Table.Cell>{data.meta_id}</Table.Cell>
                //   <Table.Cell>{data.published_id}</Table.Cell>
                //   <Table.Cell>{data.premium_post}</Table.Cell>
                //   <Table.Cell>{data.refresh_status}</Table.Cell>
                //   <Table.Cell>{data.rejected}</Table.Cell>
                //   <Table.Cell>{data.unpublish_msg}</Table.Cell>
                //   <Table.Cell>{data.publish}</Table.Cell>
                //   <Table.Cell>{data.updated_at}</Table.Cell>
                //   <Table.Cell>
                //     {data.updated_by}
                //     <br />
                //     {data.email}
                //   </Table.Cell>
                //   <Table.Cell>{data.created}</Table.Cell>
                // </Table.Row>
                <div key={data.id} className='job-detail-history-item'>
                  <b>Meta ID</b> - {data.meta_id} {data.published_id ? <>  <b>Publish ID</b> - {data.published_id}</> : null}
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                      <b> {data.title} </b> <br />
                      <b>Tags :</b> {[data.Tag1, data.Tag2, data.Tag3, data.Tag4, data.Tag5, data.Tag6, data.Tag7, data.Tag8, data.Tag9, data.Tag10, data.tag11].filter(i => !!i).join(", ")}<br />
                      <b>Experience :</b> {data.Min} - {data.Max} <br />
                      <b>Salary :</b> {data.minsal} - {data.maxsal} <br />
                      <b>Location :</b> {data.created_by_alias} <br />
                      {data.reject_msg ? <><b>Reject Reason : </b>{data.reject_msg} <br /></> : null}
                      {data.unpublish_msg ? <><b>Unpublish Reason : </b>{unpublishMsgMap[data.unpublish_msg] || data.unpublish_msg} <br /></> : null}
                    </div>
                    <div>
                      <span><b>{(getStatus(data).text || "").toUpperCase()}</b></span> <br /><br />
                      <b>Action By</b><br />
                      {data.email} <br />
                      {moment(data.updated_at).format("DD-MM-YYYY HH:mm:ss")}
                    </div>
                  </div>
                  <div>
                    <br />
                    <div style={{ cursor: "pointer", padding: "5px 0px" }} onClick={() => toggleCollapse(data)}> <b> Description </b>  </div>
                    {
                      data.hideJd ? null :
                        <p style={{ padding: "15px", background: "#e1e1e1" }} dangerouslySetInnerHTML={{ __html: data.introtext }}></p>
                    }
                  </div>
                  <br />
                  <hr />
                </div>
              );
            })}
          </div>
        ) : (
          "No Search Result"
        )}
      </div>
    </>
  );
}

// {
//   "id": 1726627,
//   "meta_id": 1689760,
//   "uid": 1221,
//   "Location": "Delhi NCR",
//   "Min": 0,
//   "Max": 3,
//   "Ipaddress": "180.151.241.2",
//   "Tag1": "",
//   "Tag2": "",
//   "Tag3": "",
//   "Tag4": "",
//   "Tag5": "",
//   "Tag6": "",
//   "Tag7": "",
//   "Tag8": "",
//   "Tag9": "",
//   "Tag10": "",
//   "tag11": "",
//   "created": "2025-02-19T06:06:19.000Z",
//   "title": "Test Job (0-3 yrs)",
//   "introtext": "<p>Job Title: Banking Insurance Specialist</p><p>Location: [Insert Location]</p><p>Employment Type: [Full-Time/Part-Time]</p><p>Job Overview:</p><p>We are seeking a skilled and customer-focused professional for the role of Banking Insurance Specialist. This position is ideal for individuals with a strong understanding of banking and insurance services who are committed to delivering tailored financial solutions. As a part of our dynamic team, you will play a vital role in bridging banking and insurance products to meet clients' financial protection needs.</p><p>Key Responsibilities:</p><p>Customer Relationship Management:</p><p>Build and maintain strong relationships with existing and prospective clients.</p><p>Conduct needs analysis to understand clients' financial goals, ensuring alignment with suitable insurance products.</p><p>Serve as a trusted advisor, providing insights on insurance offerings and financial security solutions.</p><p>Insurance Product Promotion:</p><p>Educate clients about various banking insurance products, including life, health, property, and business insurance.</p><p>Proactively identify cross-selling and upselling opportunities to enhance customer portfolios.</p><p>Collaborate with bank teams to promote bundled financial products where insurance complements banking services.</p><p>Operational Support:</p><p>Process insurance applications, renewals, and policy changes accurately and efficiently.</p><p>Assist clients with claim submissions, ensuring prompt resolution while maintaining compliance with insurance regulations.</p><p>Update customer records and ensure all documentation is complete and accurate.</p><p>Regulatory Compliance:</p><p>Stay updated on industry regulations, company policies, and legal requirements related to banking and insurance.</p><p>Ensure all client interactions and transactions adhere to regulatory and ethical standards.</p><p>Market and Risk Analysis:</p><p>Monitor market trends and customer preferences to suggest innovative product offerings.</p><p>Evaluate financial risks and advise clients on coverage options that suit their individual or business needs.</p><p>Team Collaboration:</p><p>Work closely with bank staff, insurance underwriters, and other stakeholders to deliver seamless service.</p><p>Participate in training sessions to stay updated on product knowledge and compliance requirements.</p><p>Qualifications and Skills:</p><p>Bachelor's degree in Finance, Business Administration, or a related field.</p><p>Proven experience in banking, insurance, or financial services is preferred.</p><p>Strong knowledge of insurance products and banking operations.</p><p>Excellent communication, negotiation, and interpersonal skills.</p><p>Analytical mindset with the ability to assess financial risks and develop suitable solutions.</p><p>Proficiency in CRM software and Microsoft Office Suite.</p><p>Why Join Us?</p><p>Opportunity to work in a collaborative and innovative environment.</p><p>Comprehensive training programs to enhance your professional growth.</p><p>Competitive compensation package with performance-based incentives.</p><p>The chance to make a meaningful impact on clients' financial security.</p><p>Application Process:</p><p>If you are passionate about helping clients achieve financial stability and protection through expert guidance, we encourage you to apply. Submit your resume and cover letter highlighting your relevant experience and achievements.</p>",
//   "catid": 5,
//   "created_by": 0,
//   "created_by_alias": "Delhi NCR",
//   "location_ids": "1",
//   "other_location": "",
//   "publish": 0,
//   "unpublish_msg": 0,
//   "rejected": 0,
//   "reject_msg": "",
//   "published_id": 0,
//   "jobfeedrefId": "0",
//   "last_updated": 0,
//   "company_name": "",
//   "salshow": 1,
//   "minsal": 0,
//   "filterid": 0,
//   "maxsal": 0,
//   "unixtimestamp": 1739945179,
//   "replytoemail": "",
//   "industry": "",
//   "functional_area": 18,
//   "reply_to_email": "",
//   "applyurl": "",
//   "unpublished_date": "0000-00-00",
//   "premium_post": 0,
//   "female_candidate": 0,
//   "differently_abled": 0,
//   "ex_defence": 0,
//   "work_home": 0,
//   "female_back_workforce": 0,
//   "frommobile": 0,
//   "batch": "0",
//   "maxbatch": "0",
//   "course_type": "1,2,3,4,5",
//   "pushnotify_status": 0,
//   "push_apn_status": 0,
//   "cnfi": 0,
//   "refresh_status": 0,
//   "video_url": "",
//   "domain_status": 0,
//   "assessment_flags": 0,
//   "media_resume": 0,
//   "designation": "Software Developer",
//   "reject_msg_id": null,
//   "updated_by": 81715,
//   "updated_at": "2025-02-19T06:06:19.000Z",
//   "updated_by_rectype": 2,
//   "email": "abhay@iimjobs.com"
// }

export default JobHistory